export var ERROR_MESAGES;
(function (ERROR_MESAGES) {
    ERROR_MESAGES["SOME_THING_WENT_WRONG"] = "SOME_THING_WENT_WRONG";
    ERROR_MESAGES["SERVICE_IS_RUNNING_ALREADY"] = "SERVICE_IS_RUNNING_ALREADY";
    ERROR_MESAGES["INCORRECT_INTERVAL_VALUE"] = "INCORRECT_INTERVAL_VALUE";
    ERROR_MESAGES["COMING_SOON_NOT_IMPLEMENTED_YET"] = "COMING_SOON_NOT_IMPLEMENTED_YET";
})(ERROR_MESAGES || (ERROR_MESAGES = {}));
//# sourceMappingURL=definitions.js.map